import { Component, Input, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { InstallationMode } from 'mbs-ui-shared@components/add-computer/add-computer.constants';
import { WizardForm } from 'mbs-ui-shared@components/add-computer/add-computer.types';
import { getTilesConfig } from 'mbs-ui-shared@components/add-computer/steps/read-manual/read-manual.constants';

import { StepComponent, StepsComponent } from 'mbs-ui-kit';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'add-computer-wizard-read-manual-step',
  templateUrl: './read-manual.component.html',
  styleUrls: ['../../add-computer.component.scss'],
  imports: [CommonModule, I18NextPipe, StepComponent, StepsComponent]
})
export class ReadManualComponent {
  private i18N = inject(I18NextPipe);

  public readonly tilesConfig = getTilesConfig(this.i18N);
  public readonly installationMode = InstallationMode;

  @Input() wizardForm: WizardForm;

  public getText(step: string, part: 'title' | 'description'): string {
    return this.i18N.transform(`shared:computers.addComputerWizard.readManualStep.${this.wizardForm.value.mode}.${step}.${part}`);
  }
}
